module.exports = __webpack_public_path__ + "media/country_flags/la-bdcc1eba.png";